import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
let TemplateMenu = class TemplateMenu extends Vue {
    itemClass(routeName) {
        return this.$route.name == routeName ? "kt-menu__item--active" : "";
    }
    onClick() {
        // Close the menu
        $("#kt_aside_close_btn").click();
    }
};
TemplateMenu = __decorate([
    Component({})
], TemplateMenu);
export default TemplateMenu;
